var headroom, myElement;

Array.prototype.append = function(el) {
  if (this.push != null) {
    this.push(el);
  }
  return this;
};

myElement = document.querySelector("header");

headroom = new Headroom(myElement, {
  offset: 128,
  classes: {
    notTop: "header--not-top"
  }
});

headroom.init();

new WOW({
  offset: 400
}).init();

document.addEventListener('DOMContentLoaded', function() {
  var popoverTriggerList;
  popoverTriggerList = document.querySelectorAll('.nav-link[data-content-id]');
  return [...popoverTriggerList].map(function(popoverTriggerEl, index, triggersArray) {
    var offsetX, pci;
    offsetX = (function() {
      switch (index) {
        case 0:
          return 300;
        case 1:
          return 175;
        case 2:
          return 100;
        case 3:
          return -75;
        case 4:
          return -250;
        case 5:
          return -150;
        default:
          return 0;
      }
    })();
    pci = $(popoverTriggerEl).data("content-id");
    return new bootstrap.Popover(popoverTriggerEl, {
      placement: 'bottom',
      html: true,
      trigger: 'manual',
      container: $(popoverTriggerEl).parent(),
      content: document.getElementById(`popoper-content-${pci}`),
      offset: [offsetX, 50],
      customClass: 'tips-popover'
    });
  });
});
